import type { LayoutVariant } from './types';
import IntentHeroBlock from './components/blocks/IntentHeroBlock';
import InformationalKnowledgeBlock from './components/blocks/InformationalKnowledgeBlock';
import NavigationalShortcutsBlock from './components/blocks/NavigationalShortcutsBlock';
import CommercialComparisonBlock from './components/blocks/CommercialComparisonBlock';
import TransactionalExecutionBlock from './components/blocks/TransactionalExecutionBlock';
import SystemReasoningPanel from './components/SystemReasoningPanel';

export const componentRegistry: Record<string, LayoutVariant> = {
  informational: {
    id: 'informational-default',
    intent: 'INFORMATIONAL',
    slots: {
      hero: (props) => <IntentHeroBlock {...props} />,
      primary: (props) => <InformationalKnowledgeBlock {...props} />,
      secondary: (props) => <NavigationalShortcutsBlock {...props} />,
      support: (props) => <SystemReasoningPanel classification={props.classification} />,
    },
  },
  navigational: {
    id: 'navigational-default',
    intent: 'NAVIGATIONAL',
    slots: {
      hero: (props) => <IntentHeroBlock {...props} />,
      primary: (props) => <NavigationalShortcutsBlock {...props} />,
      support: (props) => <SystemReasoningPanel classification={props.classification} />,
    },
  },
  commercial: {
    id: 'commercial-default',
    intent: 'COMMERCIAL',
    slots: {
      hero: (props) => <IntentHeroBlock {...props} />,
      primary: (props) => <CommercialComparisonBlock {...props} />,
      actions: (props) => <InformationalKnowledgeBlock {...props} />,
      support: (props) => <SystemReasoningPanel classification={props.classification} />,
    },
  },
  transactional: {
    id: 'transactional-default',
    intent: 'TRANSACTIONAL',
    slots: {
      hero: (props) => <IntentHeroBlock {...props} />,
      primary: (props) => <TransactionalExecutionBlock {...props} />,
      secondary: (props) => <CommercialComparisonBlock {...props} />,
      support: (props) => <SystemReasoningPanel classification={props.classification} />,
    },
  },
};

export function getLayoutVariant(intent: LayoutVariant['intent']): LayoutVariant {
  switch (intent) {
    case 'INFORMATIONAL':
      return componentRegistry.informational;
    case 'NAVIGATIONAL':
      return componentRegistry.navigational;
    case 'COMMERCIAL':
      return componentRegistry.commercial;
    case 'TRANSACTIONAL':
      return componentRegistry.transactional;
  }
}